<template>
    <li class="menu-item" :class="[liClass, 'level-' + item.level]">
        <button v-if="item?.type == 'verbb\\navigation\\nodetypes\\PassiveType'" class="menu-button" type="button" @click="e => onMenuItemClick(e)">
            {{ item.title }}
        </button>
        <NuxtLinkLocale
            v-else
            class="menu-link"
            :to="useConvertedMenuLink(item)"
            :target="item.newWindow ? '_blank' : '_self'"
            :external="item.newWindow == '_blank'"
            :title="item.title"
            >{{ item.title }}</NuxtLinkLocale
        >
        <slot name="childrens" />
    </li>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        item?: CmsItem;
        liClass?: string;
    }>(),
    {
        item: () => ({}),
        liClass: 'level-1'
    }
);

const item = computed(() => props.item);
const liClass = computed(() => props.liClass);

const emit = defineEmits(['onMenuItemClick']);
const onMenuItemClick = (e: MouseEvent) => emit('onMenuItemClick', e);
</script>
